import styled from 'styled-components';

export const RecaptchaDisclaimerWrapperSt = styled.div`
  color: ${({ theme }) => theme.colors.neutral500};
  font-size: ${({ theme }) => theme.fontSizes.p3};
  line-height: 1rem;
  margin-bottom: 0.5rem;
  text-align: center;
`;
